import { backgroundPalette } from "@/styles/themes/colors/palettes";

export const aliasBackground = {
  main: backgroundPalette.alto[20],
} as const;

export type AliasBackgroundScheme = `background`;

export type AliasBackground = `${AliasBackgroundScheme}.${keyof typeof aliasBackground}`;
